import { render } from "./personalTax.vue?vue&type=template&id=797afe50&scoped=true"
import script from "./personalTax.vue?vue&type=script&lang=js"
export * from "./personalTax.vue?vue&type=script&lang=js"

import "./personalTax.vue?vue&type=style&index=0&id=797afe50&lang=scss&scoped=true"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-797afe50"]])

export default __exports__